import { createSlice } from '@reduxjs/toolkit';
import { ref } from 'yup';

const userReducer = createSlice({
    name: 'user',
    initialState: {
        isLoggedIn: false,
        access_token: '',
        refresh_token: ''


    },
    reducers: {
        setUserInfo: (state, action) => {            
            state.access_token = action.payload.token || action.payload.newAccessToken;
            state.refresh_token = action.payload.refresh_token;
            state.isLoggedIn = action.payload.token ? true : false;
        },
        clearUserInfo: (state) => {
            state.isLoggedIn = false;
            state.access_token = '';
            state.refresh_token = '';
        }
        // opendetail: (state, action) => {
        //     state.detail = true;
        // },
        // offdetail: (state, action) => {
        //     state.detail = false;
        //     state.fullsize = false;
        // },
        // openfullsize: (state, action) => {
        //     state.fullsize = true;
        // },
        // closefullsize: (state, action) => {
        //     state.fullsize = false;
        // },
        // handlefullsize: (state, action) => {
        //     state.fullsize = !state.fullsize;
        //     state.autofit = !state.autofit;
        // },
        // handleOpenDraw: (state, action) => {
        //     state.openDraw = !state.openDraw;
        // },
    },
});

export default userReducer;
